import { render } from "./PersonSelect.vue?vue&type=template&id=34f0c3df&ts=true"
import script from "./PersonSelect.vue?vue&type=script&lang=ts"
export * from "./PersonSelect.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__